<ng-container *ngIf="hasAnySanction">
  <span [title]="fullTitle" class="tag tag--active tag--small is-uppercase ml-5" *ngIf="isDisputed">Sankce</span>
  <span [title]="baseTitle" class="tag tag--danger tag--small is-uppercase ml-5" *ngIf="!isDisputed">Sankce</span>
</ng-container>
